import { TEXT_CATALOG_LANE } from "../profiles/catalogLane.js";
import { loadOpenRouterRoutingEnv } from "../sync/openRouterRoutingEnv.js";
import type { ModelResolverOptions } from "../sync/modelNameResolver/types.js";
import { resolvePreferOpenRouterPreference } from "./preferOpenRouter.js";
import type { InvokeModelResolutionOptions } from "./types.js";

export function buildInvokeModelResolverOptions(
  options: Pick<
    InvokeModelResolutionOptions,
    "routingEnv" | "preferOpenRouter" | "catalogLane"
  > = {},
): ModelResolverOptions {
  const routingEnv = options.routingEnv ?? loadOpenRouterRoutingEnv();
  const preferOpenRouter = resolvePreferOpenRouterPreference(options.preferOpenRouter);
  return {
    routingEnv,
    catalogLane: options.catalogLane ?? TEXT_CATALOG_LANE,
    routeViaOpenRouter: preferOpenRouter,
  };
}
